<!--
移动端：选择支付方式

<template>
  <div>
    <el-button @click="visible=true">show</el-button>
    <SelectPaymentMethod v-model="paymentMethod" :totalAmount="5000" :visible.sync="visible" @payNow="payNow" />
  </div>
</template>

<script>
import SelectPaymentMethod from '@/components/mobile/SelectPaymentMethod.vue'
export default {
  components: { SelectPaymentMethod },
  data() {
    return {
      paymentMethod: 0,
      visible: false
    }
  },
  methods: {
    payNow(paymentMethod) { }
  }
}
</script>
-->

<template>
  <van-popup v-model="visible" position="bottom" @close="close">
    <div class="mobile-select-payment-method">
      <h4 class="center-text not-bold gray-color">{{$t('Order.List.Components.PayDialog.PaymentAmount')}}</h4>
      <h3 class="center-text">US ${{$t(totalAmount)}}</h3>
      <!-- <div
        v-for="item in paymentMethodList"
        :key="item.paymentMethod"
        class="mobile-payment-method f-b-c"
        :class="[ item.paymentMethod === 0 && balanceDisabled ? 'radio-disabled' : '' ]"
        @click="paymentMethodChange(item.paymentMethod)">
        <p>
          {{item.paymentMethodName}}
          <img v-if ="item.paymentMethod == 4" class="pay-icon" src="@/assets/img/icon/creditcard1.png" alt=""/>
          <img v-else-if ="item.paymentMethod == 2" class="pay-icon" src="@/assets/img/icon/paypal.png" alt=""/>
          <img v-else-if ="item.paymentMethod == 3" class="pay-icon" src="@/assets/img/icon/zfb_wx.png" alt=""/>
          <template v-if="item.paymentMethod === 0">${{balance}}</template>
        </p>
        <span class="radio" :class="[+paymentMethod === item.paymentMethod ? 'radio-activated' : '']"></span>
      </div> -->
      <div class="mobile-payment-method f-b-c" :class="[ balanceDisabled ? 'radio-disabled' : '' ]" @click="paymentMethodChange(0)">
        <p>{{$t('confirmOrder.balance')}} ${{balance}}</p>
        <span class="radio" :class="[+paymentMethod === 0 ? 'radio-activated' : '']"></span>
      </div>
      <!-- <div v-if="$store.state.common.userGroup === 100" class="mobile-payment-method f-b-c" @click="paymentMethodChange(4)">
        <p>{{$t('confirmOrder.creditCard')}} <img class="pay-icon" src="@/assets/img/icon/creditcard1.png" alt=""/></p>
        <span class="radio" :class="[+paymentMethod === 4 ? 'radio-activated' : '']"></span>
      </div>
      <div v-else class="mobile-payment-method f-b-c" @click="paymentMethodChange(9)">
        <p>{{$t('confirmOrder.creditCard')}} <img class="pay-icon" src="@/assets/img/icon/creditcard1.png" alt=""/></p>
        <span class="radio" :class="[+paymentMethod === 9 ? 'radio-activated' : '']"></span>
      </div> -->
      <!-- 2025.06.09 信用卡逻辑调整 全部用空中云汇的（陈琼瑜） -->
      <div class="mobile-payment-method f-b-c" @click="paymentMethodChange(4)">
        <p>{{$t('confirmOrder.creditCard')}} <img class="pay-icon" src="@/assets/img/icon/creditcard1.png" alt=""/></p>
        <span class="radio" :class="[+paymentMethod === 4 ? 'radio-activated' : '']"></span>
      </div>
      <div class="mobile-payment-method f-b-c" @click="paymentMethodChange(2)">
        <p>Paypal <img class="pay-icon" src="@/assets/img/icon/paypal.png" alt=""/></p>
        <span class="radio" :class="[+paymentMethod === 2 ? 'radio-activated' : '']"></span>
      </div>
      <div class="mobile-payment-method f-b-c" @click="paymentMethodChange(3)">
        <p>Others <img class="pay-icon" src="@/assets/img/icon/zfb_wx.png" alt=""/></p>
        <span class="radio" :class="[+paymentMethod === 3 ? 'radio-activated' : '']"></span>
      </div>
      <!-- 是否添加配件 -->
      <div class="productParts bg-white content_item">
        <h3>{{ $t('Components.Mobile.SelectPaymentMethod.CustomizedService') }}</h3>
        <el-checkbox-group v-model="attachmentSelectedList" @change="changeAttachmentSelected">
          <!-- <el-checkbox :label="item.type" v-for="item in attachmentsList" :key="item.skuCode"></el-checkbox> -->
          <template v-for="item in defaultAttachmentsList">
            <el-checkbox :key="item" :label="item" :disabled="!attachmentsList.some(e=>e.type === item)"></el-checkbox>
          </template>
          <!-- 目前只有一个吊牌，待后续新增后再去除这两个 -->
          <!-- <template v-if="attachmentsList.length < 2"> -->
            <!-- <el-checkbox :label="$t('Components.Mobile.SelectPaymentMethod.Tips1')" :disabled="false"></el-checkbox>
            <el-checkbox :label="$t('Components.Mobile.SelectPaymentMethod.Tips2')" :disabled="true"></el-checkbox> -->
          <!-- </template> -->
        </el-checkbox-group>
      </div>
      <el-button class="mobile-paynow" type="primary" @click="payNow">{{$t('orderList.PayNow')}}</el-button>
    </div>
  </van-popup>
</template>

<script>
import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'

import getPaymentMethod from '@/config/paymentMethod.js'
export default {
  components: { 'van-popup': popup },
  model: {
    prop: 'paymentMethod',
    event: 'paymentMethodChange'
  },
  props: {
    // 需要支付的总金额，如果小于用户余额，那么余额支付方式将被禁用
    totalAmount: {
      type: Number,
      default: 0,
      required: true
    },
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    radioValue: {
      type: Number,
      default: 0,
      required: true
    },
    attachmentsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      paymentMethodList: getPaymentMethod.call(this),
      attachmentSelectedList: [],
      defaultAttachmentsList: [
        'Tags',
        'Bags',
        'Cards'
      ]
    }
  },
  computed: {
    paymentMethod() {
      return this.radioValue
    },
    balance() {
      return this.$store.state.common.balance
    },
    // 余额支付方式是否被禁用
    balanceDisabled() {
      return this.balance < this.totalAmount
    }

  },
  watch: {
    // 当打开popup，当前支付方式是余额支付，且余额不足以支付，自动选择其他支付方式
    visible: function(value) {
      if (value && this.paymentMethod === 0 && this.balanceDisabled) this.paymentMethodChange(this.paymentMethod++)
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    paymentMethodChange(paymentMethod) {
      if (paymentMethod === 0 && this.balanceDisabled) return
      this.$emit('paymentMethodChange', paymentMethod)
    },
    payNow() {
      // 当前支付方式为信用卡支付，且没有设置收货地址，提示用户去设置收货地址（前海需要收货地址中的信息）
      if (this.paymentMethod === 1 && this.$store.state.common.addressList.length === 0) return this.$message.info(this.$t('promptText.msg8'))
      this.$emit('payNow', { paymentMethod: this.paymentMethod, attachmentSelectedList: this.attachmentSelectedList })
      this.close()
    },
    setAttachmentSelectedList(arr) {
      this.attachmentSelectedList = arr
    },
    changeAttachmentSelected() {
      this.$emit('changeAttachment', this.attachmentSelectedList)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-select-payment-method{
  padding: .3rem;
  h3{
    font-size: .32rem;
    line-height: .48rem;
    font-weight: bold;
  }

  .mobile-payment-method{
    padding-top: .3rem;
    div{
      height: .55rem;
    }
    .mobile-payment-method-title{
      font-weight: 500;
      font-size: .32rem;
      padding: .3rem 0;
    }
    .radio{
      display: inline-block;
      width: .32rem;
      height: .32rem;
      border: 0.5px solid #747A87;
      border-radius: 100%;
    }
    .radio-activated::after{
      content: '';
      display: block;
      width: .15rem;
      height: .15rem;
      border-radius: 100%;
      background: #99C41C;
      margin: .07rem 0 0 .065rem;
    }
  }
  .radio-disabled{
    color: #c0c4cc!important;
    .radio{
      background-color: #f5f7fa;
      border-color: #e4e7ed;
    }
  }
  .mobile-paynow{
    width: 100%;
    height: .84rem;
    margin-top: 1rem;
  }
}
.pay-icon{
  height: 18px;
  position: relative;
  top: 4px;
}
.center-text {
    text-align: center;
  }

.gray-color {
  color: gray;
}

.not-bold {
  font-weight: normal;
}
.productParts {
  margin: 10px 0;
  h3{
    font-size: .32rem;
    font-weight: bold;
    line-height: .48rem;
    margin-bottom: 8px;
  }
}
</style>
